import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-sucess',
  templateUrl: './dialog-sucess.component.html',
  styleUrls: ['./dialog-sucess.component.scss']
})
export class DialogSucessComponent {

    title: string = '';
    subTitle: string = '';
    titleBtn: string = '';

    constructor(
      private dialogRef: MatDialogRef<DialogSucessComponent>,
      @Inject( MAT_DIALOG_DATA ) public _data: any,
    ) {
      this.title = _data?.title;
      this.subTitle = _data?.subTitle;
      this.titleBtn = _data?.titleBtn;
    }

    onButtonClick(): void {
      if (this.titleBtn === 'Prosseguir') {
        this.dialogRef.close(true);
        return;
      }

      this.dialogRef.close(false);
    }

}
